import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EvaluationAdventuresModel } from './EvaluationAdventuresModel';
@Injectable({
  providedIn: 'root'
})
export class EvaluationAdventuresService {

  
  constructor(private http: HttpClient ) { }
  baseUrl = environment.baseApiUrl;
  token = localStorage.getItem("token");
  httpOptions = {
   headers: new HttpHeaders({
      "Authorization": "Bearer " + this.token,
      "Content-Type": "application/json"
   })
 };

 

 GetAllByAdventureIdId(foodId:number): Observable<any> {
   
  return this.http
    .get<any>(`${this.baseUrl}EvaluationAdventures/GetAllByAdventureIdId/${foodId}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

insert(payload: EvaluationAdventuresModel): Observable<any> {
  
  return this.http
    .post<any>(`${this.baseUrl}EvaluationAdventures/Insert`, payload,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}
}
